import React, { memo, useEffect, useState } from 'react'
import { Row, Container } from '@paypalcorp/pp-react'
import { useLocation } from '@reach/router'
import Spinner from '../common/dsr-spinner'
import { ZETTLE_VERIFICATION_API } from '../../../constants/constants'
import { post } from '../../../utils/ajax.js'
import { serverData, fptiCustomImpression } from '../../../utils'

const useQuery = (queryParam) => {
  const search = new URLSearchParams(useLocation().search)
  return search.get(queryParam)
}
const EmailVerification = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { dsrFpti = {} } = props

  const token = useQuery('token')
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(dsrFpti.EMAILVERIFICATION_IMPRESSION)
    }

    let reqparams = {
      _csrf: serverData._csrf,
      verificationToken: token || '',
    }
    async function postVerificationRequest() {
      const messageToState = {
        TOKEN_VERIFIED: 'SUCCESS',
        TOKEN_EXPIRED: 'EXPIRED',
        CLOSED: 'CLOSED',
        ERROR: 'ERROR',
        DEFAULT: 'ERROR',
      }
      let response = await post(ZETTLE_VERIFICATION_API, reqparams)
      if (response && response.success) {
        const { data: { msg = '', reqID = '' } = {} } = response
        props.setReqId(reqID)
        props.changeState(messageToState[msg] || messageToState.DEFAULT)
      } else {
        props.changeState(messageToState.DEFAULT)
      }
    }
    postVerificationRequest()
  }, [])

  return (
    <Container form>
      <Row>
        <Spinner />
      </Row>
    </Container>
  )
})
EmailVerification.displayName = 'EmailVerification'

export default EmailVerification
